export default "__VITE_ASSET__Cw1mNvP8__"